import {
  CHECK_BOX_VALUE,
  CURRENCY_CODE,
  GRID_ROWS_PER_PAGE,
  PRICING_DATA,
} from '../../../constants';

export const initialState = {
  nameContainsSearchTerm: '',
  isPricesGetData: false,
  getPriceSheetFlag: false,
  searchedPriceClassName: '',
  //changes in copypricesheet
  srcPriceSheetAccGrp: '',
  srcPriceSheetCountry: '',
  dstPriceSheetAccGrp: '',
  dstPriceSheetCountry: '',
  apiSuccessResponse: {
    create: false,
    update: false,
    copyPriceSheet: false,
  },
  accountingGroups: [],
  status: 'idle',
  loading: false,
  errors: {},
  countries: [],
  priceTypes: [],
  serachTerm: '',
  filteredData: [], // You can store the filtered data here
  isResultsFound: false, // variable for result found here
  selectedSearchTerm: null,
  gridCountryRowSelectedData: [], // You can store the grid row selected data here
  gridCountryRowSelectedCount: 0,
  gridAccountingRowSelectedData: [], // You can store the grid row selected data here
  gridAccountingRowSelectedCount: 0,
  priceSheetData: [],
  priceSheeetSearchDataLoading: false,
  deferralPriceSheetNoteData: [],
  standardLogisticsPriceSheetNoteData: [],
  openAccountingModal: false, // variable for open modal here
  openCountryModal: false, // variable for open modal here
  alertDialog: false, // variable for open Alert here
  accoutingGroupSearchForm: {
    accountGroupName: '',
    isActive: CHECK_BOX_VALUE.yes,
    isResellerGroup: CHECK_BOX_VALUE.no,
  },
  countrySearchForm: {
    name: '',
    countryCode: '',
  },
  countrySearchData: [],
  accountingGroupSearchData: [],
  usCurrencyId: CURRENCY_CODE.usa, //hardcoded value for currency ID as we do not getting mapping while doing Copy Price Sheet
  priceSheetForm: {
    countryId: 0,
    pricingTypeId: 0,
    activeFlag: CHECK_BOX_VALUE.yes,
    accountingGroup: '',
    accountGroupName: '',
    effectiveDate: new Date(),
    createdDate: new Date(),
    recordsPerPage: GRID_ROWS_PER_PAGE.priceSheetGrid,
    pageNumber: 1,
    countryName: '',
  },
  selectededTab: 0,
  selectedPreDefTabVal: 0,
  selectedPreLogTabVal: 0,
  isDeferralPriceSheet: false,
  isLogisticFeesSheet: false,
  notesData: {
    noteId: 0,
    pricing_Id: 0,
    pricing_Note_Id: 0,
    noteTypeId: 2,
    userId: 0,
    userFirstName: '',
    userLastName: '',
    comment: '',
    lastModifiedUserId: 0,
    lastModifiedTimestamp: new Date(),
  },
  logisticFeeData: {
    consumableFee: 0,
    percentMargin: 0,
  },
  accountingGroupFilteredData: [],
  countryFilteredData: [],
  alertText: PRICING_DATA.errorAlert,
  priceSheetSelectedData: {
    priceSheetId: 0,
    countryId: 0,
    countryCode: '',
    countryName: '',
    activeFlag: '',
    effectiveDate: new Date(),
    accountingGroupCode: '',
    accountingGroupName: '',
    pricingTypeId: 0,
    pricingType: '',
    createdDate: new Date(),
  },
  pricesData: [],
  priceSheetAuditTrailData: [],
  priceSheetNotesData: [],
  priceClassSearch: {
    priceClassName: '',
  },
  isModalOpen: false,
  notesSelectedGridData: [],
  priceSheetDataById: {},
  priceClasses: {
    pricing_Id: 0,
    priceClassId: 0,
    priceClassName: '',
    lastModifiedUserId: 0,
    lastModifiedTimestamp: '',
  },

  originalPriceSheet: {
    priceSheet: {},
    priceClasses: [],
    serviceOfferings: [],
    notes: [],
  },
  changedPriceSheet: {
    priceSheet: {},
    priceClasses: [],
    serviceOfferings: [],
    notes: [],
  },
  isEditClick: false,
  isEditNotes: false,
  priceClassSearchGrid: [],
  searchServiceOffer: {
    serviceName: '',
  },
  priceSheetTotalCount: 0,
  priceClassSelectBYId: [],
  serviceOfferingSearchGrid: [],
  countryTotalCount: 0,
  accountingTotalCount: 0,
  serviceOffringsListData: [],
  priceSheetSave: '',
  updatedPriceSheetData: [],
  priceClassRadio: 'withinlist',
  isSearchPriceModalOpen: false,
  isSearchServiceModalOpen: false,
  isPriceSheetResults: false,
  isCountryResults: false,
  isAccountingGroupsResults: false,
  isPriceClassesResults: false,
  priceClassesTotalCount: 0,
  isDuplicatePriceClasses: false,
  isPriceSheetSaveResults: false,
  isCopyPriceSheetSaveResults: false,
  saveAndClosePriceSheet: false,
  duplicatePriceSheetObj: [],
  originalPriceSheetWithServiceOffring: [],
  changedPriceSheetWithServiceOffring: [],
  isClickedRowIndex: null,
  isDuplicateServiceOfferings: false,
  serviceOfferingTotalCount: 0,
  serviceOfferingsCountCall: false,
  calculatedFees: '',
  calculatedFeesField: 'calculatedFees',
  priceSheetExistTotalCount: 0,
  alertDialogCopyExist: false, // variable for open Alert for Existing Pricesheet here on Copy Pricesheet
  alertDialogExist: false, // variable for open Alert for Existing Pricesheet here
  alertTextExist: PRICING_DATA.errorAlertExist,
  //Copy Price Sheet
  copyPriceSheetData: [],
  isCopyPriceSheetBtnVisible: false,
  openCopyPriceSheetModal: false, // variable for open modal here
  openCopyPriceSheetAccountingModal: false, // variable for open modal here
  openCopyPriceSheetCountryModal: false, // variable for open modal here
  accoutingGroupCopyPriceSheetSearchForm: {
    accountGroupName: '',
    isActive: CHECK_BOX_VALUE.no,
    isResellerGroup: CHECK_BOX_VALUE.no,
  },
  countryCopyPriceSheetSearchForm: {
    name: '',
    countryCode: '',
  },
  copypriceSheetForm: {
    countryId: 0,
    accountingGroup: '',
    accountGroupName: '',
    effectiveDate: new Date(),
  },
  alertDialogDuplicateCountry: false, // variable for open Alert for Same Destination Country here
  destinationPriceSheetData: '',
  sourcePriceSheet: {},
  destinationPriceSheet: {},
  newPriceSheetId: -1,
  userId: 0,
  isUpdatedDeferralSheet: false,
  isUpdatedLogisticSheet: false,
  saveReason: '',
  backPriceSheet: false
};
